export class ImportacaoSearchProps {
    constructor(
        public query: string = ''
    ) { }
}